module.exports = __webpack_public_path__ + "img/horizontal_7_6_5.4cd19817.png";